<template>
    <div class="demo-spin-article"">
        <Table :loading="showloading" :height="minheight" :data="tableData1" class="tableBorder" :columns="tableColumns1" size="default" @on-select="onRowSelected" @on-select-cancel="onRowCannel" @on-select-all="onSelectAll" @on-select-all-cancel="onSelectAllCancel" :no-data-text="ndtxt" :max-height="maxHeight"></Table>
        <!-- <br> -->
        <Row style="margin-top:10px;">
            <Col span="24">
            <Page ref="pager" :total="pageTotal" :current.sync="PageIndex" @on-change="changePage" show-total show-elevator></Page>
            </Col>
        </Row>
    </div>
</template>
<script>
// import tabledata from '../../../../static/api/tabledata.json'
import SelectData from '../../../assets/json/selectData.json'
import { mapGetters } from 'vuex'
import More from "../../../api/common/more.js"
import eventBus from '../../common/event_bus.js'
import store from "../../../store/"
import moment from 'moment'
let MoreFun = new More()
export default {
    name: "SearchResult",
    props: {
        tData: Object,
        orderTypeId: {
            type: Number,
            default: 1,
        },
        noDataText: {
            type: String,
            default: '暂无数据'
        }
        //cData:Object,
    },
    data: function() {
        return {
            minheight:600,
            showloading:true,
            isexpert:false,
            istable: false,
            isws: false,
            isjd: false,
            iscase: false,
            ndtxt: this.noDataText,
            timer: false,
            screenwidth: document.body.clientWidth,
            formItem: {
                industryselected: [],
            },
            tagList: SelectData.industry,
            tableData1: [], //this.tData.tabrows, //this.mockTableData1(), //tabledata.tabrows,
            tableColumns1: [], //this.tData.header, //this.mockTableHeader(),
            showHeaders: [],
            // showfilename:false,
            sliders: this.getSliders(),
            tempHeader: [],
            pageTotal: 8,
            PageIndex: 1,
            classId: "",
            condition: "",
            tableName: "",
            showChkBox: false,
            //testData1: this.tData
            //tdata1: this.tData
            tempData: {},
            checkedList: [], //已选择的项
            lastCheckAllList: [], //当前index的全选项,取消时需要从checkedList中移除
            currentPageIndex: 1,
            mediaWidth: 1660,
            maxHeight: 0,
        }
    },
    inject: ['CreatePage', 'getSliders'],
    methods: {
        // getSpecialProvisionData(){
        //   console.log(this.tData)
        //   return tData
        // },
        checkUserLogin() {
            // console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        onSelectAll(rows) {
            console.log('pageindex:' + this.currentPageIndex)
            var checkedItem = {
                index: this.currentPageIndex,
                checked: rows,
            }
            let _index = this.lastCheckAllList.findIndex(item => item.index === this.currentPageIndex)
            if (_index < 0) {
                this.lastCheckAllList.push(checkedItem)
            }
            //this.lastCheckAllList=rows
            console.log(this.lastCheckAllList)

            for (let i = 0; i < rows.length; i++) {
                let index = this.checkedList.findIndex(item => item.docid === rows[i].docid)
                if (index < 0) {
                    this.checkedList.push(rows[i])
                }
            }
            //发送到resultTag修改btn状态
            if (this.checkedList.length > 0) {
                this.$emit("selectUpload-checked", this.checkedList.length)
            }

        },
        onSelectAllCancel(rows) {


            //移除全局
            var chklist = []
            let pageAllList = this.lastCheckAllList.find(item => item.index === this.currentPageIndex)
            if (pageAllList !== undefined) {
                chklist = pageAllList.checked
            }
            console.log('chklist:' + chklist.length)
            let list = this.checkedList.slice(0)
            for (let i = 0; i < chklist.length; i++) {
                list.splice(list.findIndex(item => item.docid === chklist[i].docid), 1)
            }
            this.checkedList = list

            //移除当前记录的全选缓存
            let _index = this.lastCheckAllList.findIndex(item => item.index === this.currentPageIndex)
            this.lastCheckAllList.splice(_index, 1)


            //发送到resultTag修改btn状态
            // if (this.checkedList.length > 0) {
            //   this.$emit("selectUpload-checked", this.checkedList.length)
            // }
            this.$emit("selectUpload-checked", this.checkedList.length)
            console.log(this.lastCheckAllList)
        },
        getDocIdChecked() {
            let docIdList = [] //需要提交给后端插入云端
            if (this.checkedList.length > 0) {
                for (let i = 0; i < this.checkedList.length; i++) {
                    docIdList.push(this.checkedList[i].docid)
                }
            }
            return docIdList
        },
        getChecked() {
            return this.checkedList;
        },
        showListTotal() {
            //点击确定时计数已被清空
            // console.log("checkedList"+this.checkedList.length)
            return this.checkedList.length
        },
        clearChkList() {
            this.checkedList = []
        },
        onRowSelected(selection, row) {
            this.checkedList.push(row)
            //发送到resultTag修改btn状态
            if (this.checkedList.length > 0) {
                this.$emit("selectUpload-checked", this.checkedList.length)
            }
            //console.log(this.checkedList)
        },
        onRowCannel(selection, row) {
            //console.log(row.docid)
            let list = this.checkedList.slice(0) //深拷贝
            //console.log(list.findIndex(item => item.docid === row.docid))
            list.splice(list.findIndex(item => item.docid === row.docid), 1)
            this.checkedList = list
            if (this.checkedList.length >= 0) {
                this.$emit("selectUpload-checked", this.checkedList.length)
            }
            //console.log(this.checkedList)
        },
        //检查页访问权限
        //warninglevel=1,游客，2=沒有购买，3=購買了但是权限不夠
        checkAccessPromission() {
            console.log("this.getVersion====>" + this.getVersion)
            console.log("this.$refs.pager.currentPage===>" + this.$refs.pager.currentPage)
            console.log(this.tempData)
            if (this.tempData.warninglevel === 0) {
                return true
            } else if (this.tempData.warninglevel === 1 && !this.checkUserLogin()) {
                //提示登录
                console.log('检查页面访问权限1===>')
                eventBus.$emit("user-login", "true", '2') //临时登录,2=登录成功需要刷新页面地方版
                // if (this.getVersion === "1") {
                //     eventBus.$emit("user-login", "true", '1') //临时登录,1=登录成功需要刷新页面全国版
                //     return false
                // } else if (this.getVersion === "2") {
                //     eventBus.$emit("user-login", "true", '2') //临时登录,2=登录成功需要刷新页面地方版
                //     return false
                // }
            } else if (this.tempData.warninglevel === 2) {
                if (this.$refs.pager.currentPage > 1) {
                    //提示去商城
                    console.log('检查页面访问权限2===>')
                    eventBus.$emit('user-nopermission-board', this.tempData.warningtext, 1)
                    return false
                } else {
                    return true
                }

            } else if (this.tempData.warninglevel === 3) {
                if (this.$refs.pager.currentPage > 1) {
                    //提示去商城
                    console.log('检查页面访问权限2===>')
                    eventBus.$emit('user-nopermission-board', this.tempData.warningtext, 2)
                    return false
                } else {
                    return true
                }
            }
        },
        show(data) {
            console.log("show====>")
            console.log(data)
            this.isws = data.isws
            this.isjd = data.isjd //控制头的显示切换（解答/政策）
            this.iscase = data.iscase
            this.istable = data.istable
            this.isexpert=data.isexpert
            this.tempData = data
            //console.log(data)
            // this.classId=data.classid
            this.tableName = data.tabname
            this.pageTotal = data.total
            this.PageIndex = data.index
            //为了适应云端列表需求，特别处理云端来的数据
            if (data.source !== undefined) {
                this.tableData1 = this.mockTableData1(data.tabrows, data.source)
            } else {
                this.tableData1 = this.mockTableData1(data.tabrows)
            }
            //在路由切换时存在已分屏的情况，在已分屏情况下需要判断是否处于分屏在渲染table的header
            if (this.sliders.length > 0) {
                this.tableColumns1 = this.mockTableHeader(data.header, ['chk', 'fname'])
            } else {
                //this.tableColumns1 = this.mockTableHeader(data.header, '')
                this.tableColumns1 = this.mockTableHeader(data.header, data.showColumns)
            }
            this.showloading=false
            this.minheight=0
            this.$nextTick(() => {

            })
        },
        findItem(file) {
            // let index = this.checkedList.findIndex(item => item.docid === file.docid)
            let index = this.checkedList.findIndex(item => item.strdocid === file.strdocid)
            return index
        },
        mockTableData1(tabrows, source) {
            // console.log(tabrows)
            let da = [];
            let items = tabrows //this.tData.tabrows
            let chkList = []
            let checked = false
            //console.log(this.tData);
            //var items=JSON.parse(tabledata.tabrows);
            //var x=h('Tag', {props: {type: 'dot',color:red}}, "txt");
            //var len = items.length
            // let random = Math.floor(Math.random() * len)
            // if (random === 0) {
            //   random = 1
            // }
            //console.log(this.checkedList)
            //console.log("mockTableData1:"+items.length)
            if (items === null) {
                return []
            }
            if (items !== undefined && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    if (this.showChkBox) {
                        //let k = this.checkedList.findIndex(item => item.d ocid === items[i].docid)
                        let index = this.findItem(items[i])
                        if (index >= 0) {
                            checked = true
                        } else {
                            checked = false
                        }
                    } else {
                        checked = false
                    }
                    //console.log("source:"+source)
                    if (source === undefined) {
                        da.push({
                            strdocid: items[i].strdocid,
                            docid: items[i].docid,
                            fname: items[i].fname,
                            fname1: items[i].fname1,
                            fcode: items[i].fcode,
                            pdate: this.isws ? moment.unix(items[i].pbdate).format('YYYY年MM月DD日') : items[i].pdate,
                            psource: items[i].psource,
                            publisher: items[i].publisher,
                            court: items[i].court,
                            author: items[i].author,
                            reporter: items[i].reporter,
                            potence: items[i].potence,
                            masterdocid:items[i].masterdocid,
                            masterdoch1:items[i].masterdoch1,
                            masterdocidstr:items[i].masterdocidstr,
                            h1hit: items[i].h1hit,
                            chit: items[i].chit,
                            cutwords: items[i].cutwords,
                            chitseq: items[i].chitseq,
                            _checked: checked,
                        })
                    } else {
                        da.push({
                            strdocid: items[i].strdocid,
                            docid: items[i].docid,
                            fname: items[i].h1,
                            fcode: items[i].h2,
                            lastchangeeffectdate: items[i].lastchangeeffectdate,
                            lastchangeeffectstate: items[i].lastchangeeffectstate,
                            uploadtime: items[i].updatetime,
                            seqid: items[i].seqid,
                            _checked: checked,
                        })
                    }

                }
            }
            //console.log(chkList)
            return da;
        },
        mockTableHeader(header, headerTitle) {
            // console.log('mockTableHeader====>')
            // console.log(this.isws)
            // console.log(header)
            // console.log("headerTitle:"+headerTitle)
            // console.log(this.tempHeader)
            if (header !== null) {
                this.tempHeader = header
            }
            let da = [];
            let items = this.tempHeader //this.tData.header;
            let newHeaders = [];
            // let offset = 0
            // if (this.getLeftExpand === undefined) {
            //   offset = 0
            // } else if (!this.getLeftExpand) {
            //   offset = 35;
            // }
            //console.log(header)
            // if(headerTitle.length>0){
            //   this.setHeader(headerTitle)
            // }else{
            //    this.setHeader(header.showColumns)
            // }
            this.setHeader(headerTitle)
            //console.log(this.showHeaders)
            // console.log(items)

            if (items !== undefined && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    if (this.showHeaders.indexOf(items[i].key) >= 0) {
                        newHeaders.push(items[i])
                    }
                }
            }
            //console.log("newHeaders:"+newHeaders.length)
            //console.log(newHeaders)
            items = newHeaders;
            //console.log("items.........")
            for (var i = 0; i < items.length; i++) {
                //let w = parseInt(items[i].width) + offset
                //console.log(w)
                //如果分辨率小于mediawidth则均分列
                //如果分辨率大于mediawidth则限定其他列的固定宽度，剩余宽度填充到文件名列
                if (items[i].key === "fname") {
                    da.push({
                        title: this.isjd ? '标题' : items[i].title, //items[i].title,
                        key: items[i].key,
                        //width:this.sliders.length>0?344:555,
                        //width: 700,//w+"px",//700,//items[i].width,
                        align: items[i].align,
                        render: (h, params) => {
                            const row = params.row;
                            row.jd = this.isjd; //插入当前文档是否是解答的标识
                            row.wsw = this.isws;
                            row.case = this.iscase
                            const text = row.fname;
                            const fileid = row.strdocid;
                            const masterdocidstr =row.masterdocidstr;
                            const masterdoch1 = row.masterdoch1;
                            return this.istable ? h('div', [
                                h('span', {
                                    domProps: {
                                        innerHTML: `` + text + ``
                                    },
                                }),
                                h('a', {
                                    domProps: {
                                        innerHTML: `<span style="color:blue;font-size:14px;" > 查阅主文件</span>`
                                    },
                                    on: {
                                    'click': () => {
                                        //根据访问权限打开法规
                                        if (this.checkAccessPromission()) {
                                            console.log('open tax table file===>')
                                            console.log(row)
                                            this.add(masterdocidstr, this.orderTypeId, masterdoch1, row);
                                        }
                                    }
                                }
                                }),

                            ]) : h('a', {
                                domProps: {
                                    // innerHTML:`关于修订《中华人民共和国政府和智利共和国政府对所得避免双重征税和防止逃避税的协定》<sr>（2015年签订）</sr>的议定书<sr>（2018年签订）</sr>`
                                    innerHTML: `` + text + ``
                                },
                                on: {
                                    'click': () => {
                                        //根据访问权限打开法规
                                        if (this.checkAccessPromission()) {
                                            console.log('open file===>')
                                            console.log(row)
                                            this.add(fileid, this.orderTypeId, text, row);
                                        }
                                        // this.showfilename=true;
                                    }
                                }
                            }, text);
                        }
                    })

                } else if (items[i].key === "chk") {
                    if (this.showChkBox) {
                        da.push({
                            type: 'selection',
                            title: items[i].title,
                            key: items[i].key,
                            width: 55,
                            align: items[i].align,
                        })
                    }

                } else if (items[i].key === "fdown") {
                    //表格下载
                    if (this.istable) {
                        da.push({
                            type: 'action',
                            title: items[i].title,
                            align: items[i].align,
                            width: 180,
                            render: (h, params) => {
                                const row = params.row;
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'default'
                                        },
                                        on: {
                                            click: () => {
                                                this.$emit('download', row)
                                                // this.remove(params.index)
                                            }
                                        }
                                    }, '下载')
                                ]);
                            }
                        })
                    }

                } else {
                    if (items[i].key === "publisher") {
                        da.push({
                            title: this.isjd ? '发布官网' : items[i].title, //处理解答版本的headertitle
                            width: document.body.clientWidth < this.mediaWidth ? 0 : 350,
                            // width: document.body.clientWidth < this.mediaWidth?0:(window.screen.width < this.mediaWidth ? 0 : (this.sliders.length > 0 ? 0 : 350)),
                            key: items[i].key,
                            align: items[i].align,
                        })
                    } else if (items[i].key === "pdate") {
                        da.push({
                            title: this.isjd ? '发布时间' : items[i].title, //处理解答版本的headertitle
                            width: this.isws || this.isexpert ? 300 : 180,
                            key: items[i].key,
                            align: items[i].align,
                        })
                    } else if (items[i].key === "court") {
                        da.push({
                            title: items[i].title, //处理解答版本的headertitle
                            width: 300,
                            key: items[i].key,
                            align: items[i].align,
                        })
                    } else if (items[i].key === "reporter") {
                        da.push({
                            title: items[i].title, //处理税务案例的宽度
                            width: 500,
                            key: items[i].key,
                            align: items[i].align,
                        })
                    } else if (items[i].key === "fcode") {
                        da.push({
                            title: items[i].title, //处理涉税表单的宽度，文号
                            width: this.istable ? 500 : 190,
                            key: items[i].key,
                            align: items[i].align,
                        })
                    } else {
                        da.push({
                            title: items[i].title,
                            width: document.body.clientWidth < this.mediaWidth ? 0 : 190,
                            // width: document.body.clientWidth < this.mediaWidth?0:(window.screen.width < this.mediaWidth ? 0 : (this.sliders.length > 0 ? 0 : 190)),
                            key: items[i].key,
                            align: items[i].align,
                        })
                    }




                }

            }
            //console.log(da)
            return da;
        },
        setHeader(arrayObj) {
            if (arrayObj === null || arrayObj === undefined || arrayObj.length === 0) {
                // this.showHeaders = ['fileid', 'filename', 'number', 'publictime', 'publicunit', 'fileforce']
                //['chk', 'docid', 'fname', 'fcode', 'pdate', 'publisher', 'potence']
                this.showHeaders = MoreFun.getColumns().default
            } else {
                this.showHeaders = arrayObj
            }
            //console.log(this.showHeaders)

        },
        // formatDate (date) {
        //     const y = date.getFullYear();
        //     let m = date.getMonth() + 1;
        //     m = m < 10 ? '0' + m : m;
        //     let d = date.getDate();
        //     d = d < 10 ? ('0' + d) : d;
        //     return y + '-' + m + '-' + d;
        // },

        changePage(index) {
            console.log('this.currentPageIndex:' + this.currentPageIndex)
            if (this.checkAccessPromission()) {
                if (this.checkUserLogin()) {
                    this.currentPageIndex = index
                    this.$emit('onPageChange', index, this.tableName)
                } else {
                    this.$nextTick(function() {
                        this.$refs.pager.currentPage = 1
                    })
                    console.log('uploadResult user-login')
                    eventBus.$emit("user-login", "true", '2') //临时登录
                }
            } else {
                this.$nextTick(function() {
                    this.$refs.pager.currentPage = 1
                })
            }
        },

        //原始
        changePage1(index) {
            console.log('this.currentPageIndex:' + this.currentPageIndex)
            //this.tableData1 = this.mockTableData1();
            if (this.checkUserLogin()) {
                this.currentPageIndex = index
                this.$emit('onPageChange', index, this.tableName)
            } else {
                //store.commit("setLoginForm", true)

                this.$nextTick(function() {
                    this.$refs.pager.currentPage = 1
                })
                console.log('uploadResult user-login')
                eventBus.$emit("user-login", "true", '0') //临时登录
                return
            }
        },
        add(fid, orderid, fname, row) {
            this.CreatePage(fid, orderid, fname, row);
        },
        reloadHeaderData(headerData, headertitle) {
            // console.log("reloadHeaderData...")
            console.log(headerData)
            console.log(headertitle)
            this.tableColumns1 = this.mockTableHeader(headerData, headertitle);
            //console.log("reloadHeaderData:"+this.tableColumns1)
            // this.$nextTick(() => {

            // })
        },
        onSlidersChanged(showheaders) {
            console.log('onSlidersChanged...')
            // console.log(this)
            // console.log(this.$router.history.current.name)
            //let routerName=this.$router.history.current.name
            //console.log("onSlidersChanged,sliders.lenth:"+this.sliders.length)
            if (this.sliders.length === 0) {
                //console.log('1111111++++++')
                this.reloadHeaderData(null, showheaders === null ? [] : showheaders)
            } else if (this.sliders.length > 0) {
                console.log('2222222222++++++')
                this.reloadHeaderData(null, ['chk', 'fname']);
            }

        },
        showCheckBox(value) {
            this.showChkBox = value
            this.show(this.tempData)
        },
        autoCheck(chklist) {

        },
    },
    watch: {
        // showfilename: function() {
        //     this.reloadHeaderData(['filename']);
        //   //console.log("go1");
        // },

        // sliders: function() {
        //   if (this.sliders.length == 0) {
        //     this.reloadHeaderData(null,[]);
        //   } else if (this.sliders.length > 0) {
        //     // console.log("fname")
        //     this.reloadHeaderData(null,['fname']);
        //   }
        //   //console.log("retulttable.sliders:"+this.sliders.length);
        // },

        // sliders: 'onSlidersChanged',
        getLeftExpand: function(v) {
            // console.log(v)
            //this.onSlidersChanged()
        },
        //window.resize处理,大于临界值固定列宽，小于临界值均分列宽
        screenwidth: function(v) {
            if (!this.timer) {
                this.screenwidth = v
                this.timer = true
                let that = this
                setTimeout(function() {
                    //console.log(v)
                    that.show(that.tempData)
                    that.timer = false
                }, 200)
            }
        },

    },
    created() {
        // this.onSlidersChanged()
        //console.log("resulttable created...")
    },
    mounted() {
        //this.onSlidersChanged()
        var that = this
        var resizeTimer = null;
        //监听窗口变化重设table column width
        // window.addEventListener('resize', () => {
        //       if (resizeTimer) clearTimeout(resizeTimer);
        //       resizeTimer = setTimeout(function () {
        //         this.screenwidth = document.body.clientWidth
        //         //that.show(that.tempData)
        //       },200)

        // })

        window.addEventListener('resize', () => {
            this.screenwidth = document.body.clientWidth

            //console.log(this.screenwidth)
        })


        // window.onresize = () => {
        //     return (() => {
        //         //window.screenWidth = document.body.clientWidth
        //         //that.screenWidth = window.screenWidth
        //         console.log(document.body.clientWidth)
        //         that.$nextTick(() => {
        //             that.show(this.tempData)
        //         })

        //         // console.log(window.screenWidth)
        //     })()
        // }


    },
    beforeDestroy() {
        // window.removeEventListener('resize', () => {
        //     this.show(this.tempData)
        // })
    },
    destroyed() {
        //window.onresize = null;
        // window.removeEventListener('resize', () => {
        //    this.show(this.tempData)
        // })
    },
    components: {

    },
    computed: {
        ...mapGetters(['getLeftExpand', 'sta', 'getVersion'])
        // header: function() {
        //   return this.tData.header
        // },
        // tabrows: function() {
        //   return this.tData.header
        // }
    },
}
</script>
<style>
.ivu-table-cell sr {
    color: #c00000;
    font-size: 12px;
}

.ivu-table-cell hit {
    background-color: yellow;
}

/*表格边框*/
.tableBorder {
    /* width: calc(100% - 2px);*/
    /*border: 1px solid #dcdee2;*/
    border-bottom: none;
    /*max-height: 50vh;
    overflow-y:scroll;*/
}

.tableBorder>.ivu-table>.ivu-table-overflowX {
    overflow-x: hidden;
}

.tableBorder>.ivu-table>.ivu-table-tip {
    overflow-x: hidden;
}
</style>
<style lang="less" scoped>
// 表头颜色,高度
.tableBorder/deep/.ivu-table th {
    background: #F5F6FA;
    height: 50px;
}
</style>